import * as THREE from 'three/build/three.module.js';

import { Entity, Utils } from './index';

enum LightType {
	SPOT,
	POINT
};

class Light extends Entity {


	constructor({
		lightType = "spot",
		intensity = 1,
		position = new THREE.Vector3(0, 0, 0)
	} = {}) {

		super();

		this.type = "Light";

		const light = new THREE.SpotLight( 0xff4444, 1 );
	    light.position.set(position);
	    light.intensity = intensity;

	    light.angle = 0.4;
	    light.penumbra = 0.05;
	    light.decay = 2;	    
	    light.distance = 200;
	    light.shadow.bias = -0.0001;
		light.shadow.radius = 5;
		light.shadow.camera.near = 1;
		light.shadow.camera.far = 1000;
		light.shadow.mapSize.x = 1024;
		light.shadow.mapSize.y = 1024;

		if(Utils.debug) {
			this.helper = new THREE.SpotLightHelper(light);
			//this.scene.add(lightHelper);
		}

		this._light = light;
		this.object = light;

	}

	set intensity(v) {
		this._light.intensity = v;
	}

}

module.exports = Light;